import React from 'react';
import { motion } from 'framer-motion';

function BackgroundAnimation() {
  return (
            <motion.div
          className="background-animation"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.5 }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
            background: 'radial-gradient(circle,rgb(154, 255, 164),rgb(4, 4, 4))',
            overflow: 'hidden',
          }}
        >
          {[...Array(30)].map((_, i) => (
            <motion.div
              key={i}
              style={{
                position: 'absolute',
                width: '10px',
                height: '10px',
                backgroundColor: '#ffffff',
                borderRadius: '50%',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
              animate={{
                y: ['-20px', '20px'],
              }}
              transition={{
                duration: Math.random() * 5 + 2,
                repeat: Infinity,
                repeatType: 'reverse',
                ease: 'easeInOut',
              }}
            />
          ))}
        </motion.div>
  );
}

export default BackgroundAnimation;
    